<template>
  <div class='map-area' :id='mapId'>
  </div>
</template>

<script>
import koreaMapDataJson from '@/assets/data/Korea.json'
import mapApi from '@/api/web/MapApi'

import { eventBus } from '@/event-bus'
import { mapGetters } from 'vuex'
import commonUI from '@/mixin/commonUI'

const statItemStore = 'statItemStore'

export default {
  name: 'MapMobile',
  mixins: [commonUI],
  props: {
    mapId: String
  },
  components: {
  },

  data: function () {
    return {
      mapView: undefined,
      mapZoomLevel: 1,
      mapViewCenter: {},
      mapLayerList: [],
      mapInfoWindowList: [],
      mapLayerColorList: ['#f08400', '#ffab0e', '#ffd249', '#ffe79e', '#ffe79e'],
      mapStatItems: [],
      mapStatItemYearList: [],
      mapStatItemFullYearList: []
    }
  },
  computed: {
    ...mapGetters(statItemStore, {
      selectedStatItems: 'selectedStatItems',
      statItemYearInfoWindowMaxCount: 'statItemYearInfoWindowMaxCount'
    }),
  },
  created () {
    eventBus.$on('sendEventMap', () => {
      // console.log('sendEventMap : ' + this.selectedStatItems.length)
      this.mapStatItems = this.selectedStatItems

      // 통계항목에 선택된 연도 추출 후 선택된 연도 목록 생성
      this.mapStatItemFullYearList = []
      for (const statItem of this.mapStatItems) {
        this.mapStatItemFullYearList = this.mapStatItemFullYearList.concat(statItem.years)
      }
      this.mapStatItemYearList = this.mapStatItemFullYearList.filter((item, index) => this.mapStatItemFullYearList.indexOf(item) === index)

      const statItemCount = this.mapStatItems.length
      const statItemYearCount = this.mapStatItemYearList.length

      if (statItemCount > 0 && statItemYearCount > 0) {
        if (this.mapStatItemYearList.length <= this.statItemYearInfoWindowMaxCount) {
          this.showMapStatDataInfoWindow()
        } else {
          alert('지도위에 표시된 통계정보는 "해당연도" 2개 이하에서만 표시 됩니다.')
          this.showMapKoreaAreaView()
        }

        eventBus.$emit('sendMapLocationBoard')
      } else {
        this.resetMap()
        eventBus.$emit('closeDataBoard')
        eventBus.$emit('closeMapLocationBoard')
      }
    })

    eventBus.$on('clickMapLayer', (areaName, areaCd) => {
      if (this.mapStatItemYearList.length > 0) {
        eventBus.$emit('showDataBoard', areaName, areaCd)
        eventBus.$emit('showMapLocationBoard', areaName, areaCd)
      }
    })
  },

  mounted: function () {
    this.initMap()
    this.initKoreaAreaLayer()
  },

  destroyed () {
    eventBus.$off('sendEventMap')
    eventBus.$off('clickMapLayer')
  },

  methods: {
    // 지도 초기화
    initMap () {
      this.mapView = window.sop.map(this.mapId, {
        minZoom: 1,
        attributionControl: false,
        measureControl: false,
        panControl: false,
        scale: false,
        closeInfoWindowOnClick: false,
        zoomSliderControl: false,
      })
      this.mapViewCenter = window.sop.utmk(1027738, 1764157)
      this.mapView.setView(this.mapViewCenter, this.mapZoomLevel)

      // 지도 이동 이벤트 (지도 센터 위치정보)
      // this.mapView.on({
      //   moveend: (event) => {
      //     console.log(event)
      //     console.log(this.mapView.getCenter())
      //   }
      // })
    },

    // 지도 기초 Layer 생성 및 설정
    initKoreaAreaLayer () {
      window.sop.geoJson(koreaMapDataJson, {
        style: function () {
          return {
            stroke: true,
            color: 'white',
            weight: 2,
            dashArray: '1',
            opacity: 0,
            fillOpacity: 0,
            fillColor: '#ffcccc'
          }
        },
        onEachFeature: this.onEachFeature
      }).addTo(this.mapView)
    },

    onEachFeature (feature, layer) {
      const mapLayerInfoWindow = {
        adm_cd: layer.feature.properties.adm_cd,
        adm_nm: layer.feature.properties.adm_nm,
        infoWindow: window.sop.infoWindow({
          closeButton: false,
          closeOnClick: false
        })
      }
      this.mapInfoWindowList.push(mapLayerInfoWindow)
      this.mapLayerList.push(layer)

      layer.on({
        mouseover: (event) => {
        },
        mouseout: (event) => {
        },
        click: (event) => {
          if (this.mapStatItemYearList.length > 0) {
            this.removeAllLayerInfoWindow()
            const infoWindow = this.getLayerInfoWindow(event.target.feature.properties.adm_cd)
            infoWindow.addTo(this.mapView)
          }
        }
      })
    },

    // 지도 데이터 정보 모두 초기화
    resetMap () {
      for (const layerIdx in this.mapLayerList) {
        const layer = this.mapLayerList[layerIdx]
        layer.setStyle({
          opacity: 0,
          fillOpacity: 0
        })
        this.mapView.closeInfoWindow(this.getLayerInfoWindow(layer.feature.properties.adm_cd))
      }
    },

    // 전국 시도별 통계 데이터 InfoWindows 표시
    showMapStatDataInfoWindow () {
      const params = []

      for (const mapItemData of this.mapStatItems) {
        const statItemParam = {
          mapSysNo: mapItemData.mapSysNo,
          mapItmNo: mapItemData.info.mapItmNo,
          years: mapItemData.years
        }
        params.push(statItemParam)
      }

      let isHeatMapType = true
      if (this.mapStatItemFullYearList.length > 1) {
        isHeatMapType = false
      }

      mapApi.searchMapInfoWindow(params).then(resultData => {
        const apInfoWindowDataList = resultData
        let mapLayerColor = ''
        for (const idx in apInfoWindowDataList) {
          const infoData = apInfoWindowDataList[idx]

          for (const layerIdx in this.mapLayerList) {
            const layer = this.mapLayerList[layerIdx]

            if (infoData.sidoId === layer.feature.properties.adm_cd) {
              if (isHeatMapType) {
                mapLayerColor = this.mapLayerColorList[Math.floor(idx / 4)]
              } else {
                mapLayerColor = this.getStyleKoreaMapColor(layer.feature.properties.adm_cd)
              }

              layer.setStyle({
                fillColor: mapLayerColor,
                opacity: 1,
                fillOpacity: 1
              })

              let contentsInfoHTML = ''
              infoData.values.forEach(element => {
                contentsInfoHTML +=
                  '<tr>' +
                  '<td><span>' + element.year + '</span></td>' +
                  '<td>' + element.mapItmNm + '</td>' +
                  '<td>' + element.itmValue + element.unitNm + '</td>' +
                  '</tr>'
              })

              const contents = '' +
                '<table>' +
                '<tbody>' +
                '<tr>' +
                '<th colspan="3">' + infoData.siNm + '<button type="button" style="font-size: 14px; color: #fff;" onclick="clickButton(\''+ infoData.siNm  +'\', \''+ infoData.sidoId  +'\')">&nbsp;상세보기</button></th>' +
                '</tr>' +
                contentsInfoHTML +
                '</tbody>' +
                '</table>'

              const infoWindow = this.getLayerInfoWindow(layer.feature.properties.adm_cd)

              const utmkXY = new window.sop.LatLng(infoData.latitude, infoData.longitude)
              infoWindow.setUTMK([utmkXY.x, utmkXY.y])
              infoWindow.setContent(contents)

              if (this.mapStatItems.length === 1) {
                infoWindow.addTo(this.mapView)
              }

              break
            }
          }
        }
        this.mapView.setView(this.mapViewCenter, this.mapZoomLevel)
      })
    },

    // 시도 통계 상세 데이터 보드
    showDetailDataBoard(areaName, areaCd) {
      eventBus.$emit('showDataBoard', areaName, areaCd)
      eventBus.$emit('showMapLocationBoard', areaName, areaCd)
    },

    // 전국 시도별 지도 레이어 표시
    showMapKoreaAreaView () {
      for (const layerIdx in this.mapLayerList) {

        const layer = this.mapLayerList[layerIdx]
        layer.setStyle({
          fillColor: this.getStyleKoreaMapColor(layer.feature.properties.adm_cd),
          opacity: 1,
          fillOpacity: 1
        })

        this.mapView.closeInfoWindow(this.getLayerInfoWindow(layer.feature.properties.adm_cd))
      }
    },

    getLayerInfoWindow (admCd) {
      for (const infoWindow of this.mapInfoWindowList) {
        if (admCd === infoWindow.adm_cd) {
          return infoWindow.infoWindow
        }
      }
    },

    removeAllLayerInfoWindow () {
      for (const layerIdx in this.mapLayerList) {
        const layer = this.mapLayerList[layerIdx]
        this.mapView.closeInfoWindow(this.getLayerInfoWindow(layer.feature.properties.adm_cd))
      }
    },

    // 전국 시도별 지도 레이어 표시
    getStyleKoreaMapColor (admCd) {
      const colorData = {
        11: '#a65f46', // 서울특별시
        31: '#dac432', // 경기도
        23: '#a1a194', // 인천광역시
        32: '#fb8a8a', // 강원도
        33: '#639688', // 충청북도
        34: '#405952', // 충청남도
        29: '#eed9d9', // 세종시
        25: '#f6a74d', // 대전광역시
        22: '#a8dfff', // 대구광역시
        35: '#a972bb', // 전라북도
        36: '#834996', // 전라남도
        24: '#cbdd78', // 광주광역시
        37: '#5aa6ff', // 경상북도
        38: '#2975ce', // 경상남도
        26: '#e95682', // 울산광역시
        21: '#3e9ec2', // 부산광역시
        39: '#ec6832' // 제주특별자치도
      }
      return colorData[admCd]
    }
  }
}
</script>

<style scoped>

</style>
